import i18n from 'i18n';

export default function NumberI18n(value) {
  return (+value).toLocaleString(i18n.language);
}
